<section class="py-10 my-10 w-full overflow-hidden">
  <div  (mouseenter)="stopAutoplay()" (mouseleave)="startAutoplay()">
    <!-- Header -->
    <div class="flex flex-wrap justify-between items-center mb-5 gap-2 px-8">
      <h1 class="text-base relative ps-2 text-gray-800 dark:text-white sm:text-lg md:text-2xl font-bold before:content-[''] before:w-2 before:h-full before:bg-primary before:absolute before:-left-3 before:top-1/2 before:-translate-y-1/2">Primetime Movies For You</h1>
      <div class="flex gap-1 sm:gap-2">
        <button
          (click)="prev()"
          class="btn btn-xs sm:btn-sm btn-circle btn-outline"
          [disabled]="currentIndex === 0">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 sm:w-5 sm:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          (click)="next()"
          class="btn btn-xs sm:btn-sm btn-circle btn-outline"
          [disabled]="currentIndex >= popularMovies.length - visibleItems">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 sm:w-5 sm:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="flex justify-center items-center h-40">
      <div class="loading loading-spinner loading-md text-[#bd9451]"></div>
    </div>

    <!-- Carousel -->
    <div *ngIf="!loading" class="relative overflow-hidden justify-between flex-nowrap  " >
      <div
        #carouselContainer
        class="flex transition-all duration-300 gap-3 sm:gap-4 md:gap-5 overflow-x-auto md:overflow-x-hidden hide-scrollbar  py-3">
        <div
          *ngFor="let movie of popularMovies"
          class="flex-none"
          [ngStyle]="{
            width: getCardWidth() 
            
          }">
          <app-mediaCard [mediaItem]="movie"    ></app-mediaCard>
        </div>
      </div>
    </div>
  </div>
</section>
